import WRAP from "WRAP-JS";
import {
  _orderBy,
  formatBaseTime,
  formatValidTime,
  translation
} from "../../../utils/FPEUtils";
import {
  configGfsGroundDh,
  configGfsGroundIcingProbController,
  configGfsGroundLayerHighCloudCoverContour,
  configGfsGroundLayerHighCloudCoverGradation,
  configGfsGroundLayerIcingProb,
  configGfsGroundLayerIsotach,
  configGfsGroundLayerIsotachGradation,
  configGfsGroundLayerIsotachMesh,
  configGfsGroundLayerIsotherm,
  configGfsGroundLayerIsothermGradation,
  configGfsGroundLayerIsothermGrid,
  configGfsGroundLayerLowCloudCoverContour,
  configGfsGroundLayerLowCloudCoverGradation,
  configGfsGroundLayerMediumCloudCoverContour,
  configGfsGroundLayerMediumCloudCoverGradation,
  configGfsGroundLayerPrecipitation1hContour,
  configGfsGroundLayerPrecipitation1hGrid,
  configGfsGroundLayerPrecipitation1hMesh,
  configGfsGroundLayerPressuremslContour,
  configGfsGroundLayerPressuremslHiLo,
  configGfsGroundLayerRelativeHumidityContour,
  configGfsGroundLayerRelativeHumidityGradation,
  configGfsGroundLayerStreamLine,
  configGfsGroundLayerVisibilityContour,
  configGfsGroundLayerVisibilityGradation,
  configGfsGroundLayerWindArrow,
  configGfsGroundSpeedDirectionController,
  configGfsGroundUpConversionController
} from "./config/ConfigGfsGround";
import { WX_ID_GFS } from "../../../store/WeatherContentsState";
import { nearValidTime } from "../helper/MapUtil";
import MissingDataObserver from "../helper/MissingDataObserver";
import { COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD } from '../../../constants/ErrorMessage';

class GfsGround {
  static NAME = `${WX_ID_GFS}_GROUND`;
  static WIND_ARROW_NAME = `${GfsGround.NAME}_WIND_ARROW`;
  static WIND_STREAM_NAME = `${GfsGround.NAME}_WIND_STREAM`;
  static ISOTACH_CONTOUR_NAME = `${GfsGround.NAME}_ISOTACH_CONTOUR`;
  static ISOTACH_MESH_NAME = `${GfsGround.NAME}_ISOTACH_MESH`;
  static ISOTACH_GRADATION_NAME = `${GfsGround.NAME}_ISOTACH_GRADATION`;
  static ISOTHERM_CONTOUR_NAME = `${GfsGround.NAME}_ISOTHERM_CONTOUR`;
  static ISOTHERM_GRADATION_NAME = `${GfsGround.NAME}_ISOTHERM_GRADATION`;
  static ISOTHERM_GRID_NAME = `${GfsGround.NAME}_ISOTHERM_VALUE`;
  static ICING_PROB_NAME = `${GfsGround.NAME}_ICING_PROB_NAME`;
  static PRECIPITATION_1H_MESH_NAME = `${GfsGround.NAME}_PRECIPITATION_1H_MESH`;
  static PRECIPITATION_1H_CONTOUR_NAME = `${GfsGround.NAME}_PRECIPITATION_1H_CONTOUR`;
  static PRECIPITATION_1H_GRID_NAME = `${GfsGround.NAME}_PRECIPITATION_1H_GRID`;
  static RELATIVE_HUMIDITY_CONTOUR_NAME = `${GfsGround.NAME}_RELATIVE_HUMIDITY_CONTOUR_NAME`;
  static RELATIVE_HUMIDITY_GRADATION_NAME = `${GfsGround.NAME}_RELATIVE_HUMIDITY_GRADATION_NAME`;
  static PRESSUREMSL_CONTOUR_NAME = `${GfsGround.NAME}_PRESSUREMSL_CONTOUR_NAME`;
  static PRESSUREMSL_HI_LO_NAME = `${GfsGround.NAME}PRESSUREMSL_HI_LO_NAME`;
  static VISIBILITY_CONTOUR_NAME = `${GfsGround.NAME}_VISIBILITY_CONTOUR_NAME`;
  static VISIBILITY_GRADATION_NAME = `${GfsGround.NAME}_VISIBILITY_GRADATION_NAME`;
  static LOW_CLOUD_COVER_CONTOUR_NAME = `${GfsGround.NAME}_LOW_CLOUD_COVER_CONTOUR_NAME`;
  static LOW_CLOUD_COVER_GRADATION_NAME = `${GfsGround.NAME}_LOW_CLOUD_COVER_GRADATION_NAME`;
  static MEDIUM_CLOUD_COVER_CONTOUR_NAME = `${GfsGround.NAME}_MEDIUM_CLOUD_COVER_CONTOUR_NAME`;
  static MEDIUM_CLOUD_COVER_GRADATION_NAME = `${GfsGround.NAME}_MEDIUM_CLOUD_COVER_GRADATION_NAME`;
  static HIGH_CLOUD_COVER_CONTOUR_NAME = `${GfsGround.NAME}_HIGH_CLOUD_COVER_CONTOUR_NAME`;
  static HIGH_CLOUD_COVER_GRADATION_NAME = `${GfsGround.NAME}_HIGH_CLOUD_COVER_GRADATION_NAME`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [GfsGround.WIND_ARROW_NAME]: false,
    [GfsGround.WIND_STREAM_NAME]: true,
    [GfsGround.ISOTACH_CONTOUR_NAME]: true,
    [GfsGround.ISOTACH_MESH_NAME]: true,
    [GfsGround.ISOTACH_GRADATION_NAME]: false,
    [GfsGround.ISOTHERM_CONTOUR_NAME]: true,
    [GfsGround.ISOTHERM_GRADATION_NAME]: false,
    [GfsGround.ISOTHERM_GRID_NAME]: false,
    [GfsGround.ICING_PROB_NAME]: true,
    [GfsGround.PRECIPITATION_1H_MESH_NAME]: true,
    [GfsGround.PRECIPITATION_1H_CONTOUR_NAME]: true,
    [GfsGround.PRECIPITATION_1H_GRID_NAME]: false,
    [GfsGround.RELATIVE_HUMIDITY_CONTOUR_NAME]: true,
    [GfsGround.RELATIVE_HUMIDITY_GRADATION_NAME]: false,
    [GfsGround.PRESSUREMSL_CONTOUR_NAME]: false,
    [GfsGround.PRESSUREMSL_HI_LO_NAME]: false,
    [GfsGround.VISIBILITY_CONTOUR_NAME]: false,
    [GfsGround.VISIBILITY_GRADATION_NAME]: false,
    [GfsGround.LOW_CLOUD_COVER_CONTOUR_NAME]: false,
    [GfsGround.LOW_CLOUD_COVER_GRADATION_NAME]: false,
    [GfsGround.MEDIUM_CLOUD_COVER_CONTOUR_NAME]: false,
    [GfsGround.MEDIUM_CLOUD_COVER_GRADATION_NAME]: false,
    [GfsGround.HIGH_CLOUD_COVER_CONTOUR_NAME]: false,
    [GfsGround.HIGH_CLOUD_COVER_GRADATION_NAME]: false,
  };

  contentsVisibleState = {...GfsGround.CONTENTS_VISIBLE_STATE_DEFAULT};
  dh;
  dhSpeedDirectionController;
  dhUpConversionController;
  dhIcingProbController;
  dhAutoUpdate = true;
  ready = false;
  layerWindArrow;
  layerStream;
  layerIsotach;
  layerIsotachMesh;
  layerIsotachGradation;
  layerIsotherm;
  layerIsothermGradation;
  layerIsothermGrid;
  layerIcingProb;
  layerPrecipitation1hMesh;
  layerPrecipitation1hContour;
  layerPrecipitation1hGrid;
  layerRelativeHumidityContour;
  layerRelativeHumidityGradation;
  layerPressuremslContour;
  layerPressuremslHiLo;
  layerVisibilityContour;
  layerVisibilityGradation;
  layerLowCloudCoverContour;
  layerLowCloudCoverGradation;
  layerMediumCloudCoverContour;
  layerMediumCloudCoverGradation;
  layerHighCloudCoverContour;
  layerHighCloudCoverGradation;
  etd;
  elapsed = 0;
  baseTime = '---';
  validTime = '---';
  altitude = 0;
  level;
  dispatcher;
  visible;
  isDark;
  //GFSタイムコントローラー
  timeController
  //自動更新フラグ
  autoRefresh = true;
  errorMessageInfo = {};

  constructor(isDark, timeController) {
    this.isDark = isDark;
    this.timeController = timeController;
    this.layerWindArrow = new WRAP.Geo.Layer(GfsGround.WIND_ARROW_NAME);
    this.layerStream = new WRAP.Geo.Layer(GfsGround.WIND_STREAM_NAME);
    this.layerIsotach = new WRAP.Geo.Layer(GfsGround.ISOTACH_CONTOUR_NAME);
    this.layerIsotachMesh = new WRAP.Geo.Layer(GfsGround.ISOTACH_MESH_NAME);
    this.layerIsotachGradation = new WRAP.Geo.Layer(GfsGround.ISOTACH_GRADATION_NAME);
    this.layerIsotherm = new WRAP.Geo.Layer(GfsGround.ISOTHERM_CONTOUR_NAME);
    this.layerIsothermGradation = new WRAP.Geo.Layer(GfsGround.ISOTHERM_GRADATION_NAME);
    this.layerIsothermGrid = new WRAP.Geo.Layer(GfsGround.ISOTHERM_GRID_NAME);
    this.layerIcingProb = new WRAP.Geo.Layer(GfsGround.ICING_PROB_NAME);
    this.layerPrecipitation1hMesh = new WRAP.Geo.Layer(GfsGround.PRECIPITATION_1H_MESH_NAME)
    this.layerPrecipitation1hContour = new WRAP.Geo.Layer(GfsGround.PRECIPITATION_1H_CONTOUR_NAME)
    this.layerPrecipitation1hGrid = new WRAP.Geo.Layer(GfsGround.PRECIPITATION_1H_GRID_NAME)
    this.layerRelativeHumidityContour = new WRAP.Geo.Layer(GfsGround.RELATIVE_HUMIDITY_CONTOUR_NAME);
    this.layerRelativeHumidityGradation = new WRAP.Geo.Layer(GfsGround.RELATIVE_HUMIDITY_GRADATION_NAME);
    this.layerPressuremslContour = new WRAP.Geo.Layer(GfsGround.PRESSUREMSL_CONTOUR_NAME);
    this.layerPressuremslHiLo = new WRAP.Geo.Layer(GfsGround.PRESSUREMSL_HI_LO_NAME);
    this.layerVisibilityContour = new WRAP.Geo.Layer(GfsGround.VISIBILITY_CONTOUR_NAME);
    this.layerVisibilityGradation = new WRAP.Geo.Layer(GfsGround.VISIBILITY_GRADATION_NAME);
    this.layerLowCloudCoverContour = new WRAP.Geo.Layer(GfsGround.LOW_CLOUD_COVER_CONTOUR_NAME);
    this.layerLowCloudCoverGradation = new WRAP.Geo.Layer(GfsGround.LOW_CLOUD_COVER_GRADATION_NAME);
    this.layerMediumCloudCoverContour = new WRAP.Geo.Layer(GfsGround.MEDIUM_CLOUD_COVER_CONTOUR_NAME);
    this.layerMediumCloudCoverGradation = new WRAP.Geo.Layer(GfsGround.MEDIUM_CLOUD_COVER_GRADATION_NAME);
    this.layerHighCloudCoverContour = new WRAP.Geo.Layer(GfsGround.HIGH_CLOUD_COVER_CONTOUR_NAME);
    this.layerHighCloudCoverGradation = new WRAP.Geo.Layer(GfsGround.HIGH_CLOUD_COVER_GRADATION_NAME);

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerPrecipitation1hMesh.setVisible(false);
    this.layerPrecipitation1hContour.setVisible(false);
    this.layerPrecipitation1hGrid.setVisible(false);
    this.layerRelativeHumidityContour.setVisible(false);
    this.layerRelativeHumidityGradation.setVisible(false);
    this.layerPressuremslContour.setVisible(false);
    this.layerPressuremslHiLo.setVisible(false);
    this.layerVisibilityContour.setVisible(false);
    this.layerVisibilityGradation.setVisible(false);
    this.layerLowCloudCoverContour.setVisible(false);
    this.layerLowCloudCoverGradation.setVisible(false);
    this.layerMediumCloudCoverContour.setVisible(false);
    this.layerMediumCloudCoverGradation.setVisible(false);
    this.layerHighCloudCoverContour.setVisible(false);
    this.layerHighCloudCoverGradation.setVisible(false);

    this.layerWindArrow.disableInteraction(true);
    this.layerStream.disableInteraction(true);
    this.layerIsotach.disableInteraction(true);
    this.layerIsotachMesh.disableInteraction(true);
    this.layerIsotachGradation.disableInteraction(true);
    this.layerIsotherm.disableInteraction(true);
    this.layerIsothermGradation.disableInteraction(true);
    this.layerIsothermGrid.disableInteraction(true);
    this.layerIcingProb.disableInteraction(true);
    this.layerPrecipitation1hMesh.disableInteraction(true);
    this.layerPrecipitation1hContour.disableInteraction(true);
    this.layerPrecipitation1hGrid.disableInteraction(true);
    this.layerRelativeHumidityContour.disableInteraction(true);
    this.layerRelativeHumidityGradation.disableInteraction(true);
    this.layerPressuremslContour.disableInteraction(true);
    this.layerPressuremslHiLo.disableInteraction(true);
    this.layerVisibilityContour.disableInteraction(true);
    this.layerVisibilityGradation.disableInteraction(true);
    this.layerLowCloudCoverContour.disableInteraction(true);
    this.layerLowCloudCoverGradation.disableInteraction(true);
    this.layerMediumCloudCoverContour.disableInteraction(true);
    this.layerMediumCloudCoverGradation.disableInteraction(true);
    this.layerHighCloudCoverContour.disableInteraction(true);
    this.layerHighCloudCoverGradation.disableInteraction(true);
  }

  setDispatcher(dispatcher) {
    this.dispatcher = dispatcher;
    this.missingDataObserver = new MissingDataObserver(this.dispatcher, MISSING_THRESHOLD, this);
  }

  async initialize() {
    try {
      await this.initData();
    } finally {
      this.initLayer();
      this.initTimeController();
      this.ready = true;
    }
  }

  initData() {
    return new Promise((resolve, reject) => {
      this.dh = new WRAP.Data(configGfsGroundDh);

      this.missingDataObserver.monitoring(GfsGround.NAME, this.dh, () => ({
        //複数のレイヤーがあるので、ここではvisibleを返すLayerの代わりを設定
        visible: () => this.visible
      }), {
        makeTimelist: (_, ref) => {
          if (!ref) return [];
          return ref.timelist.map(t => t.basetime);
        }
      });

      this.dh.updated('timelist', (ref) => {
        resolve();
        this._selectBaseValidTime(ref);

        if (this.updateTimeFunc) {
          this.updateTimeFunc()
        }
      });
      this.dh.updated('basetime', () => {
        if (this.errorMessageInfo.basetime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.basetime});
          this.errorMessageInfo.basetime = null;
        }
      }, () => {
        this.errorMessageInfo.basetime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'basetime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('validtime', () => {
        if (this.errorMessageInfo.validtime) {
          this.dispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo.validtime});
          this.errorMessageInfo.validtime = null;
        }
      }, () => {
        this.errorMessageInfo.validtime = this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'validtime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
      this.dh.updated('region', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'region'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('level', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'level'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('element', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'element'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });
      this.dh.updated('updatetime', null, () => {
        this.dispatcher({type: 'SHOW_ERROR', payload: {
          message: COMMUNICATE_ERROR_MESSAGE_NCEP_MRF_GFS_0p25,
          replacement: {data: 'updatetime'},
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_RELOAD
        }});
        reject();
      });

      this.dhSpeedDirectionController = new WRAP.Data(configGfsGroundSpeedDirectionController);
      this.dhUpConversionController = new WRAP.Data(configGfsGroundUpConversionController);
      this.dhIcingProbController = new  WRAP.Data(configGfsGroundIcingProbController);

      this.dh.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhSpeedDirectionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhUpConversionController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
      this.dhIcingProbController.validate((displayTime, data, content) => {
        return this._validateTime(data, displayTime, content);
      });
    });
  }

  initLayer() {
    this.layerWindArrow.configure(this.dh, configGfsGroundLayerWindArrow);
    this.layerStream.configure(this.dh, configGfsGroundLayerStreamLine);
    this.layerIsotach.configure(this.dhSpeedDirectionController, configGfsGroundLayerIsotach);
    this.layerIsotachMesh.configure(this.dhSpeedDirectionController, configGfsGroundLayerIsotachMesh);
    this.layerIsotachGradation.configure(this.dhSpeedDirectionController, configGfsGroundLayerIsotachGradation);
    this.layerIsotherm.configure(this.dhUpConversionController, configGfsGroundLayerIsotherm);
    this.layerIsothermGradation.configure(this.dhUpConversionController, configGfsGroundLayerIsothermGradation);
    this.layerIsothermGrid.configure(this.dh, configGfsGroundLayerIsothermGrid);
    this.layerIcingProb.configure(this.dhIcingProbController, configGfsGroundLayerIcingProb);
    this.layerPrecipitation1hMesh.configure(this.dhUpConversionController, configGfsGroundLayerPrecipitation1hMesh);
    this.layerPrecipitation1hContour.configure(this.dhUpConversionController, configGfsGroundLayerPrecipitation1hContour);
    this.layerPrecipitation1hGrid.configure(this.dhUpConversionController, configGfsGroundLayerPrecipitation1hGrid);
    this.layerRelativeHumidityContour.configure(this.dhUpConversionController, configGfsGroundLayerRelativeHumidityContour);
    this.layerRelativeHumidityGradation.configure(this.dhUpConversionController, configGfsGroundLayerRelativeHumidityGradation);
    this.layerPressuremslContour.configure(this.dhUpConversionController, configGfsGroundLayerPressuremslContour);
    this.layerPressuremslHiLo.configure(this.dh, configGfsGroundLayerPressuremslHiLo);
    this.layerVisibilityContour.configure(this.dhUpConversionController, configGfsGroundLayerVisibilityContour);
    this.layerVisibilityGradation.configure(this.dhUpConversionController, configGfsGroundLayerVisibilityGradation);
    this.layerLowCloudCoverContour.configure(this.dhUpConversionController, configGfsGroundLayerLowCloudCoverContour);
    this.layerLowCloudCoverGradation.configure(this.dhUpConversionController, configGfsGroundLayerLowCloudCoverGradation);
    this.layerMediumCloudCoverContour.configure(this.dhUpConversionController, configGfsGroundLayerMediumCloudCoverContour);
    this.layerMediumCloudCoverGradation.configure(this.dhUpConversionController, configGfsGroundLayerMediumCloudCoverGradation);
    this.layerHighCloudCoverContour.configure(this.dhUpConversionController, configGfsGroundLayerHighCloudCoverContour);
    this.layerHighCloudCoverGradation.configure(this.dhUpConversionController, configGfsGroundLayerHighCloudCoverGradation);

    this.applyMapColor(null, this.isDark);

    this.layerWindArrow.setVisible(false);
    this.layerStream.setVisible(false);
    this.layerIsotach.setVisible(false);
    this.layerIsotachMesh.setVisible(false);
    this.layerIsotachGradation.setVisible(false);
    this.layerIsotherm.setVisible(false);
    this.layerIsothermGradation.setVisible(false);
    this.layerIsothermGrid.setVisible(false);
    this.layerIcingProb.setVisible(false);
    this.layerPrecipitation1hMesh.setVisible(false);
    this.layerPrecipitation1hContour.setVisible(false);
    this.layerPrecipitation1hGrid.setVisible(false);
    this.layerRelativeHumidityContour.setVisible(false);
    this.layerRelativeHumidityGradation.setVisible(false);
    this.layerPressuremslContour.setVisible(false);
    this.layerPressuremslHiLo.setVisible(false);
    this.layerVisibilityContour.setVisible(false);
    this.layerVisibilityGradation.setVisible(false);
    this.layerLowCloudCoverContour.setVisible(false);
    this.layerLowCloudCoverGradation.setVisible(false);
    this.layerMediumCloudCoverContour.setVisible(false);
    this.layerMediumCloudCoverGradation.setVisible(false);
    this.layerHighCloudCoverContour.setVisible(false);
    this.layerHighCloudCoverGradation.setVisible(false);
  }

  initTimeController() {
    this._allLayers().forEach(layer => {
      this.timeController.addLayer(layer);
    });
    if (this.visible) {
      this.timeController.setDisplayTime(this.validTime);
    }
  }

  async drawLayer(visible) {
    this.visible = visible;
    if (!this.ready && !this.dh) {
      await this.initialize();
    }
    this.setVisible(this.visible);
  }

  getLayer() {
    return this._allLayers();
  }

  setVisible(visible, contents) {

    if (contents) {
      this.contentsVisibleState[contents] = visible;
      if (contents === GfsGround.ISOTACH_CONTOUR_NAME) {
        this.contentsVisibleState[GfsGround.ISOTACH_MESH_NAME] = visible;
      }
    }

    if (!this.ready) return;

    let target;
    switch (contents) {
      case GfsGround.WIND_ARROW_NAME:
        target = [this.layerWindArrow];
        break;
      case GfsGround.WIND_STREAM_NAME:
        target = [this.layerStream];
        break;
      case GfsGround.ISOTACH_CONTOUR_NAME:
        target = [this.layerIsotach, this.layerIsotachMesh];
        break;
      case GfsGround.ISOTACH_GRADATION_NAME:
        target = [this.layerIsotachGradation];
        break;
      case GfsGround.ISOTHERM_CONTOUR_NAME:
        target = [this.layerIsotherm];
        break;
      case GfsGround.ISOTHERM_GRADATION_NAME:
        target = [this.layerIsothermGradation];
        break;
      case GfsGround.ISOTHERM_GRID_NAME:
        target = [this.layerIsothermGrid];
        break;
      case GfsGround.ICING_PROB_NAME:
        target = [this.layerIcingProb];
        break;
      case GfsGround.PRECIPITATION_1H_MESH_NAME:
        target = [this.layerPrecipitation1hMesh];
        break;
      case GfsGround.PRECIPITATION_1H_CONTOUR_NAME:
        target = [this.layerPrecipitation1hContour];
        break;
      case GfsGround.PRECIPITATION_1H_GRID_NAME:
        target = [this.layerPrecipitation1hGrid];
        break;
      case GfsGround.RELATIVE_HUMIDITY_CONTOUR_NAME:
        target = [this.layerRelativeHumidityContour];
        break;
      case GfsGround.RELATIVE_HUMIDITY_GRADATION_NAME:
        target = [this.layerRelativeHumidityGradation];
        break;
      case GfsGround.PRESSUREMSL_CONTOUR_NAME:
        target = [this.layerPressuremslContour];
        break;
      case GfsGround.PRESSUREMSL_HI_LO_NAME:
        target = [this.layerPressuremslHiLo];
        break;
      case GfsGround.VISIBILITY_CONTOUR_NAME:
        target = [this.layerVisibilityContour];
        break;
      case GfsGround.VISIBILITY_GRADATION_NAME:
        target = [this.layerVisibilityGradation];
        break;
      case GfsGround.LOW_CLOUD_COVER_CONTOUR_NAME:
        target = [this.layerLowCloudCoverContour];
        break;
      case GfsGround.LOW_CLOUD_COVER_GRADATION_NAME:
        target = [this.layerLowCloudCoverGradation];
        break;
      case GfsGround.MEDIUM_CLOUD_COVER_CONTOUR_NAME:
        target = [this.layerMediumCloudCoverContour];
        break;
      case GfsGround.MEDIUM_CLOUD_COVER_GRADATION_NAME:
        target = [this.layerMediumCloudCoverGradation];
        break;
      case GfsGround.HIGH_CLOUD_COVER_CONTOUR_NAME:
        target = [this.layerHighCloudCoverContour];
        break;
      case GfsGround.HIGH_CLOUD_COVER_GRADATION_NAME:
        target = [this.layerHighCloudCoverGradation];
        break;
      default:
        target = this._allLayers();
    }

    if (visible && this.visible) {
      target.forEach(layer => {
        const layerName = layer.name();
        if (this.contentsVisibleState[layerName]) {
          layer.show();
        }
      });
    } else {
      target.forEach(layer => {layer.hide()})
    }

    if (contents === undefined) {
      const enabled = visible && this.autoRefresh;
      if (this.dhAutoUpdate !== enabled) {
        this.dh.setAutoUpdate('timelist', enabled);
        this.dhSpeedDirectionController.setAutoUpdate('timelist', enabled);
        this.dhUpConversionController.setAutoUpdate('timelist', enabled);
        this.dhIcingProbController.setAutoUpdate('timelist', enabled);
        this.dhAutoUpdate = enabled;
      }
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
    }
  }

  getTimeInformation() {
    return {
      id: GfsGround.NAME,
      label: `GFS ${translation('Ground')}`,
      baseTime: {
        id: GfsGround.NAME,
        time: this.baseTime
      },
      validTime: this.validTime,
      baseTimeFormatter: (time) => formatBaseTime(time.time),
      validTimeFormatter: formatValidTime
    };
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...GfsGround.CONTENTS_VISIBLE_STATE_DEFAULT};
  }

  applyIndividualAltitude(altitude) {
    if (this.altitude !== altitude) {
      this.altitude = altitude;
      const level = '0';
      if (this.level !== level) {
        this._updateDataset();
      }
    }
  }

  applyElapsed(elapsed) {
    this.elapsed = elapsed;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  applyPlanETD(etd) {
    this.etd = etd;

    if (!this.ready) return;

    this._selectBaseValidTime(this.dh.retained.timelist);
  }

  setAutoRefresh(autoFlg) {
    if (autoFlg === this.autoRefresh) {
      return;
    }

    this.autoRefresh = autoFlg;

    if (!this.ready) {
      return;
    }
    //コンテンツの自動更新を切り替え
    this.dh.setAutoUpdate('timelist', this.autoRefresh);
    this.dhSpeedDirectionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhUpConversionController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhIcingProbController.setAutoUpdate('timelist', this.autoRefresh);
    this.dhAutoUpdate = this.autoRefresh;
  }

  setUpdateTimeFunc(func) {
    this.updateTimeFunc = func;
  }

  _selectBaseValidTime(ref) {
    let timeList = ref;
    if (!timeList) return;
    timeList = timeList.timelist;

    let targetTime;
    if (!this.etd) {
      //プラン未選択時
      if (!this.autoRefresh) {
        //タイムコントローラ操作時にレーダーを追加した場合、タイムコントローラの選択時制
        targetTime = this.timeController.getCurrentTime();
      } else {
        targetTime = Date.now();
      }
    } else {
      //プラン選択時
      targetTime = this.etd.getTime() + this.elapsed * 1000;
    }

    //最新のbasetimeを取得
    const latestBasetime = _orderBy(timeList, ['basetime'], ['desc'])[0];

    const vt = nearValidTime(latestBasetime.validtime, targetTime);

    if ((vt && this.validTime !== vt) || this.baseTime !== latestBasetime.basetime) {
      this.baseTime = latestBasetime.basetime;
      this.validTime = vt;
      this._updateDataset();
    }
  }

  /**
   * タイムコントロールモード時のvalid選択
   */
  _validateTime(data, displayTime, content) {
    if (!data.retained.timelist) {
      return false;
    }
    //最新のbasetimeを取得
    const latestBasetime = _orderBy(data.retained.timelist.timelist, ['basetime'], ['desc'])[0];

    const vt = nearValidTime(latestBasetime.validtime, displayTime);
    if (vt) {
      this.validTime = content.validtime = vt;
      return true;
    }
    return false
  }

  _updateDataset() {
    if (this.baseTime !== '---' && this.validTime !== '---') {
      this.dispatcher({type: 'SET_CONTENTS_TIME', payload: this.getTimeInformation()});
      this.level = '0';

      this.layerWindArrow.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerStream.set({
        element: ['UWIND', 'VWIND'],
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotach.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachMesh.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotachGradation.set({
        element: "Speed",
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsotherm.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGradation.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIsothermGrid.set({
        element: 'AIRTMP',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerIcingProb.set({
        element: 'IcingProb',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPrecipitation1hMesh.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPrecipitation1hContour.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPrecipitation1hGrid.set({
        element: 'PRCRIN_1HOUR',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
      
      this.layerRelativeHumidityContour.set({
        element: 'RHUM',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerRelativeHumidityGradation.set({
        element: 'RHUM',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
      
      this.layerPressuremslContour.set({
        element: 'SSPRSS',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerPressuremslHiLo.set({
        element: 'SSPRSS',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerVisibilityContour.set({
        element: 'VIS',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerVisibilityGradation.set({
        element: 'VIS',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerLowCloudCoverContour.set({
        element: 'LOWCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerLowCloudCoverGradation.set({
        element: 'LOWCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerMediumCloudCoverContour.set({
        element: 'MIDCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerMediumCloudCoverGradation.set({
        element: 'MIDCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerHighCloudCoverContour.set({
        element: 'UPRCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });

      this.layerHighCloudCoverGradation.set({
        element: 'UPRCLD',
        level: this.level,
        basetime: this.baseTime,
        validtime: this.validTime,
        use: 'map'
      });
    }
  }

  _allLayers() {
    return [
      this.layerRelativeHumidityGradation,  // 相対湿度 グラデーション
      this.layerRelativeHumidityContour,    // 相対湿度 等値線
      this.layerLowCloudCoverGradation,     // 下層雲量 グラデーション
      this.layerLowCloudCoverContour,       // 下層雲量 等値線
      this.layerMediumCloudCoverGradation,  // 中層雲量 グラデーション
      this.layerMediumCloudCoverContour,    // 中層雲量 等値線
      this.layerHighCloudCoverGradation,    // 上層雲量 グラデーション
      this.layerHighCloudCoverContour,      // 上層雲量 等値線
      this.layerVisibilityGradation,        // 視程 グラデーション
      this.layerVisibilityContour,          // 視程 等値線
      this.layerPrecipitation1hMesh,        // 前一時間降水量 グラデーション
      this.layerPrecipitation1hContour,     // 前一時間降水量 等値線
      this.layerPrecipitation1hGrid,        // 前一時間降水量 グリッド値
      this.layerIsothermGradation,          // 気温 グラデーション
      this.layerIsotherm,                   // 気温 等値線
      this.layerIsothermGrid,               // 気温 グリッド値
      this.layerIsotachGradation,           // 風 グラデーション
      this.layerIsotachMesh,                // 風 当風速線
      this.layerIsotach,                    // 風 等値線
      this.layerIcingProb,                  // 着氷の指標
      this.layerWindArrow,                  // 風 矢羽
      this.layerStream,                     // 風 流線
      this.layerPressuremslContour,         // 海面更正気圧 等値線
      this.layerPressuremslHiLo,            // 海面更正気圧 高/低
    ];
  }

  applyMapColor(mapColor, isDark) {
    this.isDark = isDark;
    const style = this.isDark ? "dark" : "default";
    this.layerIsothermGrid.setStyle(style);
    this.layerIcingProb.setStyle(style);
    this.layerPrecipitation1hGrid.setStyle(style);
    this.layerPressuremslContour.setStyle(style);
    this.layerLowCloudCoverContour.setStyle(style);
    this.layerMediumCloudCoverContour.setStyle(style);
    this.layerHighCloudCoverContour.setStyle(style);
  }
}

const MISSING_THRESHOLD = {
  [GfsGround.NAME]: 46800
}

export default GfsGround;